import styled from "@emotion/styled";

export const StyledLink = styled.a`
  color: #406aff !important;
  font-weight: 500;
`;
